var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSanjivi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M44.325 7.555a5.801 5.801 0 0 1-2.304 4.634 5.801 5.801 0 0 1-2.304-4.634 5.8 5.8 0 0 1 2.304-4.635 5.801 5.801 0 0 1 2.304 4.635Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M49.075 12.283a5.808 5.808 0 0 1-4.312 2.861 5.797 5.797 0 0 1 .32-5.165 5.808 5.808 0 0 1 4.312-2.862 5.798 5.798 0 0 1-.32 5.166Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M56.085 21.739a5.797 5.797 0 0 1-5.165.32 5.792 5.792 0 0 1 2.861-4.312 5.797 5.797 0 0 1 5.166-.32 5.791 5.791 0 0 1-2.862 4.312Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M57.952 27.176a5.799 5.799 0 0 1-5.072-1.027 5.8 5.8 0 0 1 3.88-3.426 5.8 5.8 0 0 1 5.072 1.026 5.801 5.801 0 0 1-3.88 3.427Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M34.963 12.283a5.808 5.808 0 0 0 4.312 2.861 5.808 5.808 0 0 0-4.632-8.027 5.797 5.797 0 0 0 .32 5.166Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M27.952 21.739a5.797 5.797 0 0 0 5.165.32 5.791 5.791 0 0 0-2.861-4.312 5.798 5.798 0 0 0-5.166-.32 5.792 5.792 0 0 0 2.862 4.312Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M26.086 27.176c1.826.49 3.685.05 5.072-1.027a5.801 5.801 0 0 0-3.88-3.426 5.8 5.8 0 0 0-5.072 1.026 5.8 5.8 0 0 0 3.88 3.427Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M42.083 19.725a2.29 2.29 0 1 0 0-4.581 2.29 2.29 0 0 0 0 4.581Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M54.808 29.725c-1.981.774-3.072 2.403-4.283 4.214-.776 1.162-1.618 2.421-2.786 3.538.117-.029.234-.058.352-.09a1.95 1.95 0 0 0 .757-.398c1.387-1.168 2.32-2.56 3.23-3.922.831-1.246 1.645-2.459 2.757-3.363l-.03.021h.003Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M57.352 28.973c-2.235.702-3.39 2.424-4.678 4.35-.784 1.173-1.635 2.445-2.819 3.57.233-.088.46-.176.66-.258a4.181 4.181 0 0 0 1.484-1.024c.854-.926 1.52-1.936 2.171-2.928.928-1.414 1.832-2.784 3.206-3.726l-.024.016Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m52.873 35.696-.025.014a.109.109 0 0 1 .025-.014Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M59.75 28.461c-2.486.678-3.662 2.467-4.982 4.475-.565.859-1.165 1.77-1.912 2.637 1.96-1.208 3.09-2.704 4.187-4.16.818-1.09 1.618-2.152 2.714-2.957-.002 0-.005.005-.008.005Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M54.642 11.64a5.806 5.806 0 0 0-6.605 5.736l4.621-3.51.096.12c-.072.1-1.9 2.027-4.026 4.26a5.783 5.783 0 0 0 4.266-1.7 5.798 5.798 0 0 0 1.646-4.906h.002Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m31.41 13.987.096-.12 4.622 3.512a5.783 5.783 0 0 0-1.699-4.091 5.798 5.798 0 0 0-4.907-1.645 5.806 5.806 0 0 0 5.913 6.605c-2.126-2.232-3.955-4.16-4.027-4.259l.002-.002Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M48.722 19.73a3.883 3.883 0 0 0-.682-.773l-2.566 2.71a4.002 4.002 0 0 0 .195 5.706c5.443-3.026 4.275-6.045 3.053-7.642Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M35.448 19.73c.187-.28.416-.54.683-.773l2.565 2.71a4.002 4.002 0 0 1-.194 5.706c-5.443-3.026-4.275-6.045-3.054-7.642Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M52.424 36.47c-1.733.882-4.621 1.967-8.021 1.967-2.952 0-6.288-.818-9.59-3.301.68-.643 1.286-.88 1.896-.88 1.403 0 2.83 1.243 5.2 1.667.648.114 1.235.173 1.774.173 2.602 0 4.096-1.31 5.765-3.584-4.861-.043-12.547-3.776-19.859-3.776-5.504 0-10.797 2.115-14.514 9.51a33.82 33.82 0 0 1 4.048-.26c9.234 0 11.928 4.574 19.048 6.057 1.288.269 2.714.413 4.224.413 8.25 0 18.944-4.363 22.504-16.976-7.123 0-6.315 5.853-12.48 8.987l.005.002Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#808184",
    d: "M7.528 69.635h1.325v7.285H7.528v-3.227H4.362v3.227H3.037v-7.285h1.325v2.912h3.166v-2.912Zm12.291 3.637c0 .624-.094 1.173-.278 1.65a3.385 3.385 0 0 1-.757 1.193c-.32.32-.693.56-1.12.72-.427.16-.883.242-1.368.242a3.87 3.87 0 0 1-1.373-.242c-.432-.16-.806-.4-1.126-.72a3.485 3.485 0 0 1-.762-1.192c-.19-.475-.283-1.027-.283-1.651 0-.624.093-1.173.283-1.645.189-.472.448-.872.773-1.192a3.176 3.176 0 0 1 1.13-.726 3.84 3.84 0 0 1 1.358-.242c.477 0 .928.08 1.357.242.427.16.8.403 1.12.726.32.322.574.72.763 1.192.19.472.283 1.021.283 1.645Zm-5.688 0c0 .4.048.763.146 1.088.099.325.24.603.427.83.187.226.41.405.677.53.267.125.568.19.904.19.336 0 .627-.065.894-.19.266-.125.493-.304.677-.53a2.37 2.37 0 0 0 .427-.83c.098-.325.146-.688.146-1.088 0-.4-.048-.763-.146-1.088a2.37 2.37 0 0 0-.427-.83 1.936 1.936 0 0 0-.677-.53 2.077 2.077 0 0 0-.894-.19c-.328 0-.637.065-.904.19a1.867 1.867 0 0 0-.677.536 2.47 2.47 0 0 0-.427.83 3.692 3.692 0 0 0-.146 1.082Zm11.354 2.661c.478 0 .824-.08 1.04-.242.216-.16.326-.39.326-.683a.906.906 0 0 0-.11-.453 1.181 1.181 0 0 0-.314-.342 2.56 2.56 0 0 0-.5-.282 7.948 7.948 0 0 0-.671-.259 9.491 9.491 0 0 1-.73-.299 2.452 2.452 0 0 1-.622-.405 1.904 1.904 0 0 1-.432-.579 1.832 1.832 0 0 1-.163-.81c0-.659.227-1.176.683-1.55.456-.376 1.075-.562 1.861-.562.456 0 .862.05 1.214.152.354.101.632.213.834.33l-.41 1.072a3.073 3.073 0 0 0-.784-.304 3.677 3.677 0 0 0-.878-.104c-.357 0-.637.075-.834.222-.2.146-.3.354-.3.621 0 .16.033.299.1.416.066.115.16.219.282.31.123.09.267.175.432.253.166.077.344.152.542.221.344.125.65.253.92.384.269.13.498.283.682.461.187.179.328.39.427.632.099.243.147.534.147.878 0 .658-.232 1.168-.7 1.53-.466.36-1.146.542-2.044.542-.302 0-.576-.019-.824-.059a5.088 5.088 0 0 1-.662-.141 4.616 4.616 0 0 1-.498-.174 2.884 2.884 0 0 1-.336-.162l.389-1.083c.19.104.445.21.768.315.323.104.712.157 1.168.157l-.003-.003Zm8.421-6.37c1.059 0 1.87.192 2.435.578.563.387.845.99.845 1.808 0 .427-.074.795-.226 1.099a1.928 1.928 0 0 1-.656.747 3.057 3.057 0 0 1-1.051.426 6.648 6.648 0 0 1-1.419.136h-.661v2.566h-1.325V69.74c.309-.069.65-.117 1.024-.141.376-.024.72-.037 1.034-.037ZM34 70.707c-.336 0-.614.01-.83.032v2.48h.64c.638 0 1.128-.091 1.472-.267.344-.179.515-.517.515-1.013a1.21 1.21 0 0 0-.136-.6.994.994 0 0 0-.379-.379 1.835 1.835 0 0 0-.573-.195 4.27 4.27 0 0 0-.71-.058Zm6.845-1.072h1.325v7.285h-1.325v-7.285Zm10.598 0v1.146h-2.24v6.139h-1.336v-6.139h-2.24v-1.146h5.816Zm8.303 7.285c-.098-.288-.2-.57-.306-.85-.107-.28-.208-.569-.307-.862h-3.077c-.1.293-.198.584-.302.867l-.301.845h-1.379a101.443 101.443 0 0 1 1.496-4.027c.235-.589.467-1.149.699-1.682.232-.534.47-1.059.715-1.576h1.264a58.264 58.264 0 0 1 1.413 3.259 106.567 106.567 0 0 1 1.51 4.026h-1.43.005Zm-2.15-5.875c-.162.371-.346.824-.551 1.358a68.769 68.769 0 0 0-.645 1.736h2.397a77.621 77.621 0 0 0-.65-1.744c-.211-.539-.393-.99-.547-1.347l-.003-.003Zm11.55 4.731v1.147h-4.605v-7.286h1.325v6.139h3.28Zm5.225.157c.477 0 .824-.08 1.04-.242.216-.16.325-.39.325-.683a.906.906 0 0 0-.109-.453 1.181 1.181 0 0 0-.315-.342 2.562 2.562 0 0 0-.498-.282 7.975 7.975 0 0 0-.672-.259 9.494 9.494 0 0 1-.731-.299 2.45 2.45 0 0 1-.621-.405 1.9 1.9 0 0 1-.432-.579 1.83 1.83 0 0 1-.163-.81c0-.659.227-1.176.683-1.55.456-.376 1.074-.562 1.861-.562.456 0 .861.05 1.213.152.355.101.632.213.835.33l-.41 1.072a3.072 3.072 0 0 0-.785-.304 3.676 3.676 0 0 0-.877-.104c-.357 0-.637.075-.835.222-.2.146-.298.354-.298.621 0 .16.032.299.098.416.067.115.16.219.283.31.123.09.267.175.432.253.165.077.344.152.541.221.344.125.651.253.92.384.27.13.499.283.683.461.187.179.328.39.427.632.098.243.146.534.146.878 0 .658-.232 1.168-.698 1.53-.467.36-1.147.542-2.046.542-.301 0-.576-.019-.824-.059a5.088 5.088 0 0 1-.661-.141 4.616 4.616 0 0 1-.499-.174 2.884 2.884 0 0 1-.336-.162l.39-1.083c.189.104.445.21.768.315.322.104.712.157 1.168.157l-.003-.003Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7AA1B",
    d: "M7.384 63.181c.427 0 .779-.034 1.056-.106s.501-.168.67-.291a.972.972 0 0 0 .349-.437c.064-.168.096-.355.096-.563 0-.44-.208-.805-.622-1.096-.413-.29-1.125-.605-2.133-.941-.44-.155-.88-.334-1.32-.534a4.85 4.85 0 0 1-1.184-.757 3.586 3.586 0 0 1-.853-1.107c-.219-.432-.33-.96-.33-1.581s.116-1.179.348-1.677c.232-.499.563-.923.99-1.27.426-.349.944-.616 1.552-.805.608-.187 1.293-.28 2.056-.28.904 0 1.688.096 2.347.29.658.195 1.202.409 1.629.64l-.872 2.387a8.317 8.317 0 0 0-1.25-.514c-.46-.15-1.012-.224-1.66-.224-.725 0-1.245.101-1.56.301-.317.2-.474.507-.474.923 0 .245.058.453.173.621.117.168.28.32.493.456.214.136.46.259.736.368.278.11.584.224.923.339.699.258 1.307.514 1.824.765.518.253.947.547 1.29.883.342.336.598.73.766 1.184.168.453.254 1.002.254 1.648 0 1.253-.44 2.226-1.32 2.92-.88.69-2.206 1.037-3.977 1.037-.594 0-1.13-.035-1.61-.107a10.46 10.46 0 0 1-1.27-.261 7.161 7.161 0 0 1-1.618-.661l.853-2.406c.4.222.896.416 1.483.592.59.174 1.31.262 2.162.262l.003.002Zm16.64 2.307a56.79 56.79 0 0 0-.483-1.44l-.514-1.47h-5.248c-.17.491-.341.982-.51 1.475-.17.494-.33.971-.477 1.435h-3.141c.507-1.448.986-2.787 1.44-4.016.453-1.23.899-2.387 1.333-3.472a116.61 116.61 0 0 1 1.285-3.093 65.65 65.65 0 0 1 1.315-2.862h2.867A105.053 105.053 0 0 1 24.494 58a144.8 144.8 0 0 1 1.335 3.472c.454 1.23.936 2.568 1.443 4.016h-3.248ZM20.39 55.093c-.067.195-.166.462-.297.798-.13.336-.277.725-.442 1.165-.166.44-.352.925-.558 1.453-.205.531-.413 1.086-.626 1.667h3.843c-.206-.584-.406-1.139-.598-1.67a59.83 59.83 0 0 0-.55-1.458l-.455-1.165c-.13-.336-.238-.598-.317-.79Zm17.618 10.395a66.648 66.648 0 0 0-2.813-4.557 46.93 46.93 0 0 0-3.219-4.248v8.805H28.99v-13.44h2.464c.426.427.898.95 1.416 1.57a55.772 55.772 0 0 1 1.581 1.99c.536.704 1.07 1.435 1.6 2.192.53.757 1.027 1.483 1.493 2.181v-7.933h3.006v13.44h-2.542Zm12.995-4.518c0 .66-.075 1.28-.224 1.862a3.755 3.755 0 0 1-.776 1.523c-.368.432-.867.776-1.493 1.026-.627.254-1.42.379-2.377.379-.88 0-1.634-.107-2.269-.32-.634-.213-1.157-.461-1.57-.747l1.008-2.346c.376.221.776.413 1.202.581a3.79 3.79 0 0 0 1.398.253c.736 0 1.266-.181 1.589-.544.322-.362.485-.97.485-1.824v-8.765h3.027v8.923Zm2.909-8.922h3.027v13.44h-3.027v-13.44Zm10.147 13.44a99.717 99.717 0 0 1-1.584-3.515 128.985 128.985 0 0 1-2.774-7.016 136.894 136.894 0 0 1-1.018-2.909h3.336a188.359 188.359 0 0 0 1.781 5.195c.32.89.627 1.744.917 2.56.294.816.574 1.522.84 2.114.254-.589.528-1.293.827-2.109.299-.816.608-1.67.928-2.56.32-.89.632-1.787.941-2.683.31-.896.59-1.736.84-2.52h3.222c-.302.859-.648 1.83-1.04 2.912a137.846 137.846 0 0 1-2.76 7.019 95.138 95.138 0 0 1-1.576 3.51h-2.886l.006.002Zm9.986-13.44h3.027v13.44h-3.027v-13.44Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 44.304,
    x2: 49.853,
    y1: 11.131,
    y2: 11.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 13.709,
    x2: 62.96,
    y1: 33.589,
    y2: 33.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7AA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 50.92,
    x2: 58.947,
    y1: 19.744,
    y2: 19.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 52.88,
    x2: 61.829,
    y1: 24.949,
    y2: 24.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 34.184,
    x2: 39.733,
    y1: 11.131,
    y2: 11.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 25.09,
    x2: 33.117,
    y1: 19.744,
    y2: 19.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 22.208,
    x2: 31.16,
    y1: 24.949,
    y2: 24.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 39.792,
    x2: 44.374,
    y1: 17.435,
    y2: 17.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 39.714,
    x2: 44.325,
    y1: 7.555,
    y2: 7.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 13.922,
    x2: 63.17,
    y1: 32.925,
    y2: 32.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7AA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 13.755,
    x2: 63.763,
    y1: 35.701,
    y2: 35.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7AA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 14.133,
    x2: 63.384,
    y1: 32.013,
    y2: 32.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7AA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 50.485,
    x2: 53.026,
    y1: 16.629,
    y2: 11.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 32.114,
    x2: 33.581,
    y1: 15.891,
    y2: 13.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 44.373,
    x2: 49.749,
    y1: 23.165,
    y2: 23.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 39.795,
    x2: 34.419,
    y1: 23.165,
    y2: 23.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77B743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 14.347,
    x2: 63.597,
    y1: 35.971,
    y2: 35.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7AA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanjivi);
export default __webpack_public_path__ + "static/media/Sanjivi.b225bc8b3ffe42ea45033e97a8eac499.svg";
export { ForwardRef as ReactComponent };